import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ConfigurationContext from 'UserRegistration/contexts/ConfigurationContext';
import PublicPersonalInformation from 'UserRegistration/components/RegistrationSteps/PersonalInformation/PublicPersonalInformation';
import AddContactPersonalInformation from 'UserRegistration/components/RegistrationSteps/PersonalInformation/AddContactPersonalInformation';

/**
 * Displays the Add Contact version of the Billing Information section.
 * 
 * @param {object} props 
 */
function PersonalInformation(props) {

    const { componentConfig } = useContext(ConfigurationContext);

    const renderPersonalInformationAccordingToContext = () => {

        switch(componentConfig.context) {
            case 'ADD_CONTACT':
                return ( <AddContactPersonalInformation {...props} />);
            case 'PUBLIC_REGISTRATION':
                return ( <PublicPersonalInformation {...props} />);
            default:
                return ( null );
        }
    }

    return renderPersonalInformationAccordingToContext();

}

PersonalInformation.propTypes = {
    /** A reference to the Formik component. */
    formikRef: PropTypes.any,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number,
    /** Organization name of the current logged in user. */
    organizationName: PropTypes.string,
    /** List of available timezones for the current portal. */
    supportedTimezones: PropTypes.array
};

export default PersonalInformation;